module.exports = __webpack_public_path__ + "static/img/withdraw-list-banner.e41ef4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdraw/withdraw-list-banner.png
// module id = FOqk
// module chunks = 215